/**
 * DEMO-ONLY HTTP handlers for ICM `quickorder` REST (Presidio LOCAL_MOCK).
 */
import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import {
  createPresidioMockQuickOrderItems,
  deletePresidioMockQuickOrderItems,
  getPresidioMockQuickOrder,
  PresidioMockUpdateQuickOrderItem,
  updatePresidioMockQuickOrderItem,
} from './presidio-mock-quickorder';

export function handlePresidioMockQuickOrder(
  req: HttpRequest<unknown>,
  restPath: string,
  readJsonBody: <T>(body: unknown) => T
): Observable<HttpEvent<unknown>> | null {
  const method = req.method.toUpperCase();
  const collection = restPath === 'quickorder';
  const single = /^quickorder\/([^/]+)$/.exec(restPath);

  if (!collection && !single) {
    return null;
  }

  if (collection && method === 'GET') {
    return of(new HttpResponse({ status: 200, body: getPresidioMockQuickOrder(), url: req.url }));
  }

  if (collection && method === 'POST') {
    const body = readJsonBody<{ items?: PresidioMockUpdateQuickOrderItem[] }>(req.body);
    const result = createPresidioMockQuickOrderItems(body?.items || []);
    return of(new HttpResponse({ status: 200, body: result, url: req.url }));
  }

  if (collection && method === 'DELETE') {
    const body = readJsonBody<{ itemLineIds?: string[] }>(req.body);
    const result = deletePresidioMockQuickOrderItems(body?.itemLineIds || []);
    return of(new HttpResponse({ status: 200, body: result, url: req.url }));
  }

  if (single && method === 'PUT') {
    const itemId = single[1];
    const patch = readJsonBody<PresidioMockUpdateQuickOrderItem>(req.body);
    const result = updatePresidioMockQuickOrderItem(itemId, patch || { productSKU: '', quantity: 1 });
    return of(new HttpResponse({ status: 200, body: result, url: req.url }));
  }

  return null;
}
